enum Environment {
  local = 'local',
  review = 'review',
  staging = 'staging',
  production = 'production',
  dev = 'dev',
}

export { Environment };
